



















import AbpBase from "../../../lib/abpbase";
import * as echarts from "echarts";
import Ajax from "../../../lib/ajax";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
@Component
export default class echart extends AbpBase {
  pm25 = 0;
  pm10 = 0;
  pm25Num = 0.00;
  pm10Num = 0.00;
  pm25Str = "优";
  pm10Str = "优";
  aqi = 0;
  myPieChart; //饼图
  async chart() {
    let list = await this.$store.dispatch({
      type: "thequipment/getLngLat",
    });
    //空气质量
    let locations =
      parseFloat(list.longitude).toFixed(2) +
      "," +
      parseFloat(list.latitude).toFixed(2);
    await Ajax.get(
      "https://devapi.qweather.com/v7/air/now?location=" +
        locations +
        "&key=c1e9654fadd5468ca62111d848736b81"
    ).then((res) => {
      this.pm25 = parseInt(res.data.now.pm2p5);
      this.pm10 = parseInt(res.data.now.pm10);
      this.aqi = parseInt(res.data.now.aqi);
      this.pm25Num = this.pm25 / 4;
      if(this.pm25Num > 100){
        this.pm25Num = 100;
      }
      this.pm10Num = this.pm10 / 4;
      if(this.pm10Num > 100){
        this.pm10Num = 100;
      }
      if(this.pm25 > 50 && this.pm25 < 100){
        this.pm25Str = "良";
      }
      else if(this.pm25 >= 100 && this.pm25 < 150){
        this.pm25Str = "轻度污染";
      }
      else if(this.pm25 >= 150 && this.pm25 < 200){
        this.pm25Str = "中度污染";
      }
      else if(this.pm25 >= 200 && this.pm25 < 300){
        this.pm25Str = "重度污染";
      }
      else if(this.pm25 >= 300){
        this.pm25Str = "严重污染";
      }
      if(this.pm10 > 50 && this.pm10 < 100){
        this.pm10Str = "良";
      }
      else if(this.pm10 >= 100 && this.pm10 < 150){
        this.pm10Str = "轻度污染";
      }
      else if(this.pm10 >= 150 && this.pm10 < 200){
        this.pm10Str = "中度污染";
      }
      else if(this.pm10 >= 200 && this.pm10 < 300){
        this.pm10Str = "重度污染";
      }
      else if(this.pm10 >= 300){
        this.pm10Str = "严重污染";
      }
    });
    var Pieoption = {
    series: [
    {
      type: 'gauge',
      center: ['50%', '80%'],
      startAngle: 180,
      endAngle: 0,
      min: 0,
      max: 500,
      splitNumber: 4,
      itemStyle: {
        color: '#f96e33'
      },
      progress: {
        show: true,
        width: 10
      },
      pointer: {
        show: false
      },
      axisLine: {
        lineStyle: {
          width: 10
        }
      },
      axisTick: {
        show: false,
      },
      splitLine: {
         show: false,
        distance: -32,
        length: 14,
      },
      axisLabel: {
        distance: -10,
        color: '#333',
        fontSize: 15
      },
      anchor: {
        show: false
      },
      title: {
        show: false
      },
      detail: {
        valueAnimation: true,
        width: '50%',
        lineHeight: 40,
        borderRadius: 8,
        offsetCenter: [0, '-15%'],
        fontSize: 60,
        fontWeight: 'bolder',
        formatter: '{value}',
        color: 'auto'
      },
      data: [
        {
          value: this.aqi
        }
      ]
    },
  ]
};
    //饼图
    this.myPieChart = echarts.init(document.getElementById("Piechart"));
    this.myPieChart.setOption(Pieoption);
  }
  mounted() {
    this.chart();
  }
}
